import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-5" }
const _hoisted_2 = { class: "col-span-12 flex flex-col gap-5" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "col-span-12 flex py-10 text-center"
}
const _hoisted_5 = { class: "text-gray-500" }
const _hoisted_6 = { class: "col-span-12 md:col-span-6" }
const _hoisted_7 = { class: "flex gap-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "w-fit flex items-start justify-center pt-3 px-1 sm:p-1 sm:px-0 sm:pt-1 sm:items-center" }
const _hoisted_10 = { class: "grid grid-cols-12 items-center" }
const _hoisted_11 = { class: "col-span-8 mt-10 gap-7" }
const _hoisted_12 = { class: "flex justify-center text-end" }
const _hoisted_13 = { class: "col-span-4 flex flex-col gap-5" }
const _hoisted_14 = ["src"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "grid grid-cols-12 items-center" }
const _hoisted_17 = { class: "col-span-8" }
const _hoisted_18 = { class: "col-span-4 flex flex-col gap-5" }
const _hoisted_19 = { class: "flex items-center gap-1" }
const _hoisted_20 = { class: "flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!
  const _component_Info = _resolveComponent("Info")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_RankItem = _resolveComponent("RankItem")!
  const _component_ApexChart = _resolveComponent("ApexChart")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$t("stats.course.sidebar.engage")), 1)
      ])
    ]),
    (_ctx.noDataAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Card, {
            hasBorder: false,
            isEmpty: true
          }, {
            content: _withCtx(() => [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Dados não encontrados",
                  en: "Data unavailable",
                })), 1)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Card, {
              hasBorder: false,
              isEmpty: true
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Ranking de atributos para os não engajados",
                    en: "Students who turned detection off",
                  })), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("i", {
                      class: "btn-simple !p0 pi pi-info-circle !text-[1.3rem]",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = true))
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Dialog, {
                      visible: _ctx.visible,
                      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
                      modal: "",
                      header: 
                    _ctx.$t('labels.generic', {
                      pt: 'Atributos',
                      en: 'Attributes',
                    })
                  ,
                      style: { width: '50vw' },
                      breakpoints: { '1199px': '75vw', '575px': '90vw' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Info)
                      ]),
                      _: 1
                    }, 8, ["visible", "header"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankItems, (item, index) => {
                        return (_openBlock(), _createBlock(_component_RankItem, {
                          key: index,
                          src: item.src,
                          height: item.height
                        }, null, 8, ["src", "height"]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.ranks), (rank, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "items-center flex flex-col text-center"
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.getImageSrc(index),
                          alt: "",
                          class: "h-14"
                        }, null, 8, _hoisted_14),
                        _createElementVNode("p", null, _toDisplayString(rank), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.engagementCharts, (chart, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-span-12 md:col-span-6"
            }, [
              _createVNode(_component_Card, {
                hasBorder: false,
                isEmpty: true
              }, {
                content: _withCtx(() => [
                  _createElementVNode("h4", {
                    class: "mb-2",
                    innerHTML: chart.title
                  }, null, 8, _hoisted_15),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_ApexChart, {
                        type: "donut",
                        options: chart.data.options,
                        series: chart.data.series
                      }, null, 8, ["options", "series"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chart.data.legends, (item, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("h5", null, _toDisplayString(item.title), 1)
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("p", {
                              class: _normalizeClass(`${item.color} h-2 w-2 rounded-full`)
                            }, null, 2),
                            _createElementVNode("h3", null, _toDisplayString(item.number), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ], 64))
  ]))
}